import { shallowMount } from "@vue/test-utils";
import BannerBienvenidaOferta from "@/components/core/custom/BannerBienvenidaOferta.vue";

describe("BannerBienvenidaOferta component", () => {
  let wrapper;

  beforeEach(() => {
    wrapper = shallowMount(BannerBienvenidaOferta, {
      propsData: {
        title: "Bienvenido",
        premios: {},
        codigoPaquete: "04",
        description: "Mock description"
      }
    });
  });

  it("Renders del component BannerBienvenidaOferta", () => {
    expect(wrapper).toBeDefined();
  });

  it("Debe de establecer el valor por defecto", () => {
    expect(wrapper.text()).toContain("");
  });
});
